import React, { Component } from "react";
import { createPortal } from "react-dom";
import FormInputFields from '../../../../FormInputFields';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import Buttons from '../../../../../Components/UI/Buttons';
import Icons from '../../../../../Components/Icons/Icons';
import { getUserPreferredCurrencyCode } from '../../../../../Utils/CommonFunctions';

const resolvePanelCurrency = (currencyCode) => {
    if (currencyCode !== undefined && currencyCode !== null && String(currencyCode).trim() !== '') {
        return String(currencyCode).trim().toUpperCase();
    }
    return getUserPreferredCurrencyCode() || 'CAD';
};

const isValidExchangeRate = (rate) => {
    if (rate === undefined || rate === null || String(rate).trim() === '') {
        return false;
    }
    const numericRate = Number(rate);
    return !Number.isNaN(numericRate) && numericRate > 0;
};

class ExchangeRateConversion  extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepsMode:'CURRENCY',
            isOpen: false,
            menuStyle: null,
            formInputs:{
                changeCurrency: resolvePanelCurrency(this.props.currency_code),
                totalValue:0,
                exchange_rate: '',
                from_currency_code: "",
                to_currency_code: "",
                value: ''
            }
        }
     this.selectorRef = React.createRef(null);
     this.menuRef = React.createRef(null);
    }
   
    onChangeHandler = (key,value)=>{
        this.setState({
        stepsMode:'CURRENCY',
        formInputs:{
            ...this.state.formInputs,
            [key]:value,
            // Clear stale rate while new convert API is in flight so Re-calculate can't use the previous currency's rate.
            ...(key==='changeCurrency' ? { exchange_rate: '', totalValue: 0, rate_unavailable: false } : {}),
            // Manual rate entry clears the "no rate" validation and enables Re-calculate when value > 0.
            ...(key==='exchange_rate' ? { rate_unavailable: false } : {})
        }})

        if(key==='changeCurrency'){
            setTimeout(() => {
              this.getExChangeHandler();
             }, 100);            
        }
    }
    componentDidUpdate = (prevProps)=>{             
        if(this.props.exchangeRates!==prevProps.exchangeRates){            
            this.setState({
                stepsMode:'EXCHANGERATE',
                formInputs:{
                ...this.state.formInputs,
                ...this.props.exchangeRates
            } })                
        }
        if (prevProps.currency_code !== this.props.currency_code && this.props.currency_code) {
            this.setState({
                formInputs: {
                    ...this.state.formInputs,
                    changeCurrency: this.props.currency_code
                }
            });
        }
                        
    }

    componentDidMount = () => {
        this.onChangeHandler('changeCurrency',this.props.currency_code)
        document.addEventListener('mousedown', this.handleOutsideClick);
        window.addEventListener('resize', this.handleReposition);
        window.addEventListener('scroll', this.handleReposition, true);
    }

    componentWillUnmount = () => {
        document.removeEventListener('mousedown', this.handleOutsideClick);
        window.removeEventListener('resize', this.handleReposition);
        window.removeEventListener('scroll', this.handleReposition, true);
    }

    computeMenuStyle = () => {
        const btn = this.selectorRef.current;
        const width = Math.min(560, Math.max(320, window.innerWidth - 16));
        let top = 80;
        let left = 16;
        if (btn) {
            const rect = btn.getBoundingClientRect();
            top = rect.bottom + 6;
            left = rect.left;
            if (left + width > window.innerWidth - 8) {
                left = Math.max(8, window.innerWidth - width - 8);
            }
            if (left < 8) {
                left = 8;
            }
            const estimatedHeight = 320;
            if (top + estimatedHeight > window.innerHeight - 8) {
                top = Math.max(8, rect.top - estimatedHeight - 6);
            }
        }
        return {
            position: 'fixed',
            top,
            left,
            zIndex: 2050,
            width,
            minWidth: width,
            maxWidth: 'calc(100vw - 16px)',
            display: 'block'
        };
    }

    openPanel = () => {
        const panelCurrency = resolvePanelCurrency(this.props.currency_code);
        this.setState({
            isOpen: true,
            menuStyle: this.computeMenuStyle(),
            stepsMode: 'CURRENCY',
            formInputs: {
                ...this.state.formInputs,
                // Seed "Change Currency To" from the field's code; if missing, preferred; else CAD.
                changeCurrency: panelCurrency,
                totalValue: 0
            }
        }, () => {
            this.getExChangeHandler();
            if (!this.props.isOpenCurrencyConversion && typeof this.props.toogleConvertCurrency === 'function') {
                this.props.toogleConvertCurrency();
            }
        });
    }

    closePanel = () => {
        if (!this.state.isOpen) {
            return;
        }
        this.setState({ isOpen: false, menuStyle: null });
        if (this.props.isOpenCurrencyConversion && typeof this.props.toogleConvertCurrency === 'function') {
            this.props.toogleConvertCurrency();
        }
    }

    togglePanel = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (this.state.isOpen) {
            this.closePanel();
        } else {
            this.openPanel();
        }
    }

    handleOutsideClick = (e) => {
        if (!this.state.isOpen) {
            return;
        }
        const menu = this.menuRef.current;
        const btn = this.selectorRef.current;
        if (menu && menu.contains(e.target)) {
            return;
        }
        if (btn && btn.contains(e.target)) {
            return;
        }
        this.closePanel();
    }

    handleReposition = () => {
        if (!this.state.isOpen) {
            return;
        }
        this.setState({ menuStyle: this.computeMenuStyle() });
    }
    
    getExChangeHandler = ()=>{
        const {currencyValue} = this.props;
        const {formInputs} = this.state;
        const currentCurrency = resolvePanelCurrency(this.props.currency_code);
        if (typeof this.props.updateCurrencyValueByFormat !== 'function') {
            return;
        }
        this.props.updateCurrencyValueByFormat({
          fromCode:currentCurrency,
          toCode:formInputs.changeCurrency,
          selectedValue:currencyValue, 
        },true);
    }
    recalculateHandler = ()=>{
        const {currencyValue} = this.props;
        const {formInputs} = this.state;
        if (!isValidExchangeRate(formInputs.exchange_rate)) {
            return;
        }
        const totalValue = (formInputs.exchange_rate*currencyValue);
        this.setState({stepsMode:'GENERATE',
        formInputs:{
            ...formInputs,
            totalValue:totalValue
        }})
    }
    applyChangeHandler = ()=>{
        const {formInputs} = this.state;
        if (!isValidExchangeRate(formInputs.exchange_rate)) {
            return;
        }
        const updateData = this.props.fieldObj;
        const fromCode = resolvePanelCurrency(this.props.currency_code);
        const toCode = formInputs.changeCurrency;
        const total = this.props.toFixedHandler(formInputs.totalValue);
        // Companions first, then amount last so a missing exchangeRate handler
        // cannot overwrite selected_value with the rate.
        this.props.onChangeInputAction(updateData, fromCode, 'fromCurrency');
        this.props.onChangeInputAction(updateData, toCode, 'currencyType');
        this.props.onChangeInputAction(updateData, formInputs.exchange_rate, 'exchangeRate');
        this.props.onChangeInputAction(updateData, total, 'number');
        this.props.applyAndClose(total, toCode);
        this.setState({ isOpen: false, menuStyle: null });
    }

    renderPanel = () => {
        const {formInputs, menuStyle} = this.state;
        const {currencyList,currencyValue,currency_code} = this.props;
        let currencyListOptions = [];
        const seenCurrencyKeys = {};
        (currencyList || []).forEach((currency)=>{
            const currencyKey = currency && currency.key != null ? String(currency.key) : '';
            if(currencyKey === '' || seenCurrencyKeys[currencyKey]) {
                return;
            }
            seenCurrencyKeys[currencyKey] = true;
            currencyListOptions.push({
                value:currency.value,
                id:currency.key
            });
        });
        const fromCode = resolvePanelCurrency(currency_code);
        const canRecalculate = isValidExchangeRate(formInputs.exchange_rate);
        const showRateUnavailable = formInputs.rate_unavailable === true && !canRecalculate;

        return createPortal(
            <div
                ref={this.menuRef}
                className="dropdown-menu dropnotHide show currency-conversion-portal"
                style={menuStyle}
                onClick={(e) => e.stopPropagation()}
            >
					<div className="card-header bg-transparent p-1" style={{"border":"none"}}> 
						<div className="form-group mb-0 row justify-content-center align-items-center">
						    <label className="text-small col-auto text-right mb-0 pr-2"> Entered value : </label>
						    <div className="col-3">
                            <FormInputFields  
                                {...{
                                    type:'TextInput',
                                    options:currencyListOptions,
                                    value:currencyValue,
                                    attributes:{
                                        readOnly:'readOnly',
                                        className:"form-control form-control-sm",
                                        id:'from_currency',
                                        name:'from_currency',
                                    },
                                }} />
							</div>
						</div>
					</div>
					<div className="card-body">
						<div className="row">
							<div className="col-6">
								<div className="form-group">
									<label className="text-small"> Change Currency To </label>
									<div className="">
                                       <FormInputFields  
                                            {...{
                                            type:'PickList',
                                            isDefault:true,
                                            isMandatory:true,
                                            isNoneAllowed:false,
                                            options:currencyListOptions,
                                                value:formInputs.changeCurrency,
                                                attributes:{
                                                    id:'changeCurrency',
                                                    name:'changeCurrency',
                                                },
                                            changeHandler:this.onChangeHandler.bind(this,'changeCurrency'),
                                        }} />
                                    </div>
								</div>
						    </div>
					        <div className="col-6">
								<div className="form-group"> 
									<label className="text-small"> Exchange Rate <code> ( "{fromCode}" <span style={{display:'inline-block', transform:'scale(1.35)', verticalAlign:'middle', margin:'0 2px'}}><Icons iconType="IconArrowR" /></span> "{formInputs.changeCurrency}" ) </code></label>
									<div className=""> 
										<div className="input-group">
											<FormInputFields  {...{
                                                    type:'Decimal',
                                                    value:formInputs.exchange_rate,
                                                    changeHandler:this.onChangeHandler.bind(this,'exchange_rate'),
                                                    isAllowNegative:false,
                                                    attributes:{
                                                        className:"form-control form-control-sm",
                                                        id:'from_currency',
                                                        name:'from_currency',
                                                        decimal:4,
                                                        maxLength:6
                                                    },
                                                    min:0
                                                }} />
											<div className="input-group-append">
                                            <Buttons 
                                                buttonList={[
                                                    {
                                                    clickHandler:this.recalculateHandler,
                                                    attributes:{
                                                        className:"btn primary_bg",
                                                    },
                                                    disabled:!canRecalculate,
                                                    name:"Re-calculate"
                                                    }
                                                ]}/>
											</div>
										</div>
                                        {showRateUnavailable ?
                                            <label className="error m-0 text-small d-block mt-1">No exchange rate for this currency</label>
                                        : null}
									</div>								 
								</div>
                                <div className="form-group row mb-0">		 
									<div className="col-12"> 
										<div className="input-group">
                                            <FormInputFields  
                                                {...{type:'TextInput',
                                                    value:formInputs.totalValue,
                                                    attributes:{
                                                        readOnly:'readOnly',
                                                        className:"form-control form-control-sm",
                                                    }}} />
											<div className="input-group-append">
												<span className="input-group-text p-1" id="basic-addon2"> Total </span>
											</div>
										</div>
									</div>								 
								</div>
							</div>
						</div>	 
					</div>
					<div className="card-footer bg-transparent p-1">
					    <div className="row align-items-center justify-content-center"> 
                        <Buttons 
                            buttonList={[
                                {
                                clickHandler:this.applyChangeHandler,
                                attributes:{
                                    "className":"btn primary_bg mr-3",
                                },
                                disabled:(this.state.stepsMode==='GENERATE')?false:true,
                                name:"Apply"
                                },
                                {
                                attributes:{
                                    className:"btn btn-border border-default",
                                },
                                clickHandler:this.closePanel,
                                name:"Close"
                                }
                            ]}/>
						</div>
				    </div>
            </div>,
            document.body
        );
    }

    render(){
        return(
                <Wrp>
                <button
                    type="button"
                    ref={this.selectorRef}
                    className="btn btn-primary dropdown-toggle sign-up-btn"
                    aria-expanded={this.state.isOpen}
                    onClick={this.togglePanel}
                >
                    Change Currency
                </button>
                {this.state.isOpen ? this.renderPanel() : null}
             </Wrp>    
        )
    }
}
export default ExchangeRateConversion;
